import React, { useState, useEffect, useContext } from 'react';
import dataContext from '../context/User';
import FormLogin from './FormLogin';
import ThemeToggle from '../element/ThemeToggle';
import { useHistory } from 'react-router-dom';

import dataSuper from '../hooks/Conf';
import dataDE from '../hooks/useDireccionEstudiantil';
import apiURL from '../hooks/useAPI';
import logo from '../img/logo_app.jpg';
import fondoesen from '../img/esen.jpg';

const Login = () => {

    const history = useHistory();
    const { fetchAPI } = apiURL;
    const dataUser = useContext(dataContext);

    const [data, setData] = useState({ loginSource: '0', carnet: '' });
    const [cargando, setCargando] = useState(false);
    const [error, setError] = useState(null);

    const redirigir = (cred) => {
        if (+cred.success === 1 && (cred.perfil === 'Alumnos' || cred.perfil === 'Estudiante')) {
            history.push("/dashboard");
        } else if (+cred.success === 1 && (dataSuper.indexOf(cred.carnet.trim()) !== -1)) {
            history.push("/erecursos");
        } else if (+cred.success === 1 && (dataDE.indexOf(cred.carnet.trim()) !== -1)) {
            history.push("/erecursos");
        } else if (+cred.success === 1 && (cred.perfil === 'Profesores' || cred.perfil === 'Decanos' || cred.perfil === 'Administrativo' || cred.perfil === 'Docente')) {
            history.push("/erecursos");
        } else {
            history.push("/");
        }
    }

    useEffect(() => {
        let datos = localStorage.getItem('dataUser');
        if (datos) {
            let cred = JSON.parse(datos);
            dataUser.token = cred.token;
            dataUser.nombre = cred.nombre;
            dataUser.carnet = cred.carnet;
            dataUser.perfil = cred.perfil;
            redirigir(cred);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dataUser, history]);

    const hendleChange = (e) => {
        setData({
            ...data,
            [e.target.name]: e.target.value
        });
    }

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError(null);
        setCargando(true);

        let datosLogin = await loginFetch();
        setCargando(false);

        if (!datosLogin) {
            setError('No se pudo conectar con el servidor. Verifica tu conexión e intenta de nuevo.');
            return;
        }

        if (+datosLogin.success !== 1) {
            setError('Credenciales incorrectas. Son las mismas que utilizas en Registro Académico o en el CCESEN.');
            return;
        }

        //Llenando contexto
        dataUser.token = datosLogin.token;
        dataUser.nombre = datosLogin.nombre;
        dataUser.carnet = datosLogin.carnet;

        localStorage.setItem('dataUser', JSON.stringify(datosLogin));

        redirigir(datosLogin);
    }

    let loginFetch = async () => {
        try {
            data.secret = '5ec4702eff406849a82818cb';
            data.carnet === '80100004' ? data.carnet = '8010004' : data.carnet = data.carnet;
            if (data.carnet.length < 8) {
                data.loginSource = 1; //CCESEN
            } else {
                data.loginSource = 0; //Registro
            }
            if (+data.loginSource === 0) { //Registro academico
                const entryPointLogin = `${fetchAPI}registro/login`;
                const optionFetch = {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
                let res = await fetch(entryPointLogin, optionFetch);
                let datos = res.json();
                return datos;
            }

            if (+data.loginSource === 1) { //CCESEN
                data.carnet === '8010004' ? data.carnet = '80100004' : data.carnet = data.carnet;
                const entryPointLogin = `${fetchAPI}biblio/login`;
                const optionFetch = {
                    method: 'POST',
                    body: JSON.stringify(data),
                    headers: {
                        'Content-Type': 'application/json'
                    }
                }
                let res = await fetch(entryPointLogin, optionFetch);
                let datos = res.json();
                return datos;
            }

        } catch (error) {
            console.log(error);
            return null;
        }
    }


    return (
        <div className="esen-login">
            <ThemeToggle variant="page" />

            <section
                className="esen-login-brand esen-login-brand--photo"
                style={{ backgroundImage: `url('${fondoesen}')` }}
            >
                <div className="esen-login-brand-inner">
                    <img src={logo} alt="Logo ESEN" />
                    <h1>Tu portal de la comunidad ESEN</h1>
                    <p>
                        Notas, horarios, solvencia, eventos, recursos del CCESEN y más,
                        en un solo lugar.
                    </p>
                </div>
            </section>

            <section className="esen-login-panel">
                <div className="esen-login-card">
                    <h2>Iniciar sesión</h2>
                    <p>Usa tus credenciales de Registro Académico</p>

                    <FormLogin
                        onChange={hendleChange}
                        onSubmit={handleSubmit}
                        cargando={cargando}
                        error={error}
                    />

                    <div className="esen-login-foot">
                        Escuela Superior de Economía y Negocios
                        <br />
                        Todos los derechos reservados &copy; {new Date().getFullYear()}
                    </div>
                </div>
            </section>
        </div>
    );

}

export default Login
